import { LitElement, html } from "lit-element";
import "@material/mwc-checkbox";
import "@material/mwc-switch";

export class BooleanField extends LitElement {
	render() {
		return html`
        <style>
          
        
            :host {
                width: 100%;
                display: block;
                box-sizing: border-box;
                align-self: center;
                --mdc-theme-secondary: var(--secondary-color);
            }
        
            .field-wrapper{
                display: flex;
                width: 100%;
                justify-content: space-between;	
                align-items: center;		
            }

            .field-wrapper div:hover{
                cursor: pointer;		
            }
        

            mwc-checkbox[disabled]{
                pointer-events:none;
                --mdc-theme-secondary:#adb8cb;
            }
        </style>

       <div  @click="${this.handleChange}" id="wr" class="field-wrapper">
            <div>${this.label}</div>
            ${this.renderField()}
        </div>



    `;
	}

	renderField() {
		if (this.type === "toggle")
			return html`<mwc-switch ?disabled="${this.disabled}" .checked="${
				this.value
			}"></mwc-switch>`;

		else
			return html`<mwc-checkbox ?disabled="${this.disabled}" .checked="${
				this.value
			}"></mwc-checkbox>`;

	}

	constructor() {
		super();
		this.focus({ preventScroll: true });
		this.type = "toggle";
		this.handleChange = (e) => {
			e.stopPropagation();
			if (this.disabled) return;
			this.value = !this.value;
			if (this.path)
				this.dispatchEvent(
					new CustomEvent("inspx-change", {
						detail: { value: this.value, path: this.path },
						composed: true
					})
				);

			else
				this.dispatchEvent(
					new CustomEvent("change", {
						detail: { value: this.value },
						composed: true
					})
				);

		};
	}

	static get properties() {
		return {
			value: { type: Boolean, value: false },
			disabled: { type: Boolean, value: false },
			name: { type: String },
			type: { type: String }, //toggle or checkbox
			label: { type: String },
			required: { type: Boolean },
			path: { type: String }
		};
	}
}
window.customElements.define("boolean-field", BooleanField);
